module.exports = __webpack_public_path__ + "static/media/share.6ad15255.webp";